export default function NotFound() {
  return (
    <section className="text-muted-foreground p-8">
      <h1 className="text-2xl font-bold">404: Not Found</h1>
      <p className="mt-4">It's gone 😞</p>
    </section>
  );
}
